export default [
  {
    path: '/devices',
    name: 'devicelist',
    view: 'DeviceList'
  },
  {
    path: '/devices/tv',
    name: 'deviceTV',
    view: 'DeviceTV'
  },
  {
    path: '/devices/chart',
    name: 'chartPage',
    view: 'ChartPage'
  },
  {
    path: '/devices/lighting',
    name: 'lightingPage',
    view: 'LightingPage'
  },
  {
    path: '/notifications',
    name: 'notificationlist',
    view: 'NotificationsList'
  },
  {
    path: '/motions/:id',
    name: 'motionhistory',
    view: 'MotionHistory'
  },
  {
    path: '/heating/:id',
    name: 'heatinghistory',
    view: 'HeatingHistory'
  },
  {
    path: '/lighting/:id',
    name: 'lightinghistory',
    view: 'LightingHistory'
  },
  {
    path: '/scenarios',
    name: 'scenarioslist',
    view: 'ScenariosList'
  },
  {
    path: '/profile',
    name: 'profile',
    view: 'ProfilePage'
  },
  {
    path: '/empty',
    name: 'empty',
    view: 'EmptyPage'
  },
  {
    path: '/final',
    name: 'final',
    view: 'FinalPage'
  },
  {
    path: '/master',
    name: 'master',
    view: 'MasterPage'
  },
];
